import React from 'react'
import { tagMap } from '@cpsy-rmap-project/tags'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { Colors, Routes } from '../../../consts'
import { usePaperDetailsModal } from '../../molecules/PaperDetailsModal/hooks'
import { useSubmitModelDialog } from '../../molecules/SubmitModelDialog/hooks'
import { useCprmSearch } from '../../pages/Search/hooks'

interface Props {
  id: string
  isInlineBlock?: boolean
  isNowrap?: boolean
  clickable?: boolean
}

const Pill = styled.span`
  /* display: inline-block; */
  padding: 2px 4px;
  margin: 0.25em;
  color: black;
  font-size: 8px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  vertical-align: baseline;
  border-radius: 4px;
  /* white-space: nowrap; */
  /* overflow-wrap: break-word; */
`

const Component: React.FC<Props> = ({ id, isInlineBlock, isNowrap, clickable }) => {
  const history = useHistory()
  const { filterTagsV2, handleFilterTagsV2 } = useCprmSearch()
  const paperDetailsModal = usePaperDetailsModal()
  const submitModelDialog = useSubmitModelDialog()
  const closePaperDetailsModal = paperDetailsModal.handlePaperDetailsModalClose
  const closeSubmitModelDialog = submitModelDialog.handle.handleClose

  const tag = tagMap[id]

  if (!tag) {
    return <></>
  }

  const tagFiltering = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.stopPropagation() // 親クリックをキャンセルする
    if (!filterTagsV2[tag.tagAxisId].includes(tag.id)) {
      handleFilterTagsV2(tag.tagAxisId, [...filterTagsV2[tag.tagAxisId], tag.id])
      history.push(Routes.Search.path)
    }
    closePaperDetailsModal()
    closeSubmitModelDialog()
  }

  return (
    // <>{tag.name}</>
    <Pill
      style={{
        ...(clickable ? { cursor: 'pointer' } : {}),
        backgroundColor: Colors.Tags[tag.tagAxisId],
        ...(isInlineBlock ? { display: 'inline-block' } : {}),
        ...(isNowrap ? { whiteSpace: 'nowrap' } : { wordBreak: 'break-word' })
      }}
      onClick={clickable ? tagFiltering : () => {}}
    >
      {tag.name}
    </Pill>
  )
}

export default Component
